export default function parseEmail(email) {
    return email.replace(/^(.{0,4}).*@/, "$1***@");
}
